const BoosterTagfields = require('../booster/boosterTagFields');

module.exports = [
	...BoosterTagfields.SiteTagFields,
];
